import { jsx } from 'react/jsx-runtime';
import { forwardRef, Children } from 'react';
import { useMediaQuery, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { DescriptionListElement } from '../DescriptionListElement/index.esm.js';
import './styles.css';


const getDescriptionListSizeDefault = ()=>'medium';
const getDescriptionListIsVerticalOnMobileDefault = ()=>true;
const getDescriptionDirectionDefault = ()=>'horizontal';
const getDescriptionWeightDefault = ()=>'regular';
const getTermWeightDefault = ()=>'bold';
const getDescriptionListVariantDefault = ()=>'vertical';

var styles = {
    "spacing": "DescriptionList-module_spacing__qmxaA",
    "descriptionList": "DescriptionList-module_descriptionList__6FzWL",
    "descriptionListDescriptionBold": "DescriptionList-module_descriptionListDescriptionBold__74EXL",
    "descriptionListTermRegular": "DescriptionList-module_descriptionListTermRegular__nwOWo",
    "descriptionList_horizontal": "DescriptionList-module_descriptionList_horizontal__ljLbV",
    "descriptionList_vertical": "DescriptionList-module_descriptionList_vertical__kiNT2",
    "descriptionList_verticalVertical": "DescriptionList-module_descriptionList_verticalVertical__dvoXP",
    "descriptionList_small": "DescriptionList-module_descriptionList_small__Vd-Ch",
    "childWrapper": "DescriptionList-module_childWrapper__les5m"
};

const DescriptionList = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, size = getDescriptionListSizeDefault(), variant = getDescriptionListVariantDefault(), descriptionDirection = getDescriptionDirectionDefault(), descriptionWeight = getDescriptionWeightDefault(), termWeight = getTermWeightDefault(), hasSpacing, isVerticalOnMobile = getDescriptionListIsVerticalOnMobileDefault(), children }, ref)=>{
    const isMobile = !useMediaQuery('(min-width: 640px)');
    const isHorizontal = variant === 'horizontal' && (!isMobile || !isVerticalOnMobile);
    const verticalClassName = descriptionDirection === 'vertical' ? styles.descriptionList_verticalVertical : styles.descriptionList_vertical;
    const variantClassName = isHorizontal ? styles.descriptionList_horizontal : verticalClassName;
    const sizeClassName = size === 'small' ? styles.descriptionList_small : '';
    const spacingClassName = hasSpacing ? styles.spacing : '';
    const termClassName = termWeight === 'regular' ? styles.descriptionListTermRegular : '';
    const descriptionClassName = descriptionWeight === 'bold' ? styles.descriptionListDescriptionBold : '';
    const descriptionListClassname = `${styles.descriptionList} ${variantClassName} ${spacingClassName} ${sizeClassName} ${termClassName} ${descriptionClassName} ${className}`.trim();
    return /*#__PURE__*/ jsx("dl", {
        ref: ref,
        id: id,
        className: descriptionListClassname,
        lang: lang,
        "data-testid": dataTestId,
        children: variant === 'horizontal' && (!isMobile || !isVerticalOnMobile) ? Children.map(children, (child)=>/*#__PURE__*/ jsx("div", {
                className: descriptionDirection === 'horizontal' ? styles.childWrapper : undefined,
                children: child
            })) : children
    });
});
DescriptionList.displayName = 'DescriptionList';
DescriptionList.Element = DescriptionListElement;
DescriptionList.Element.displayName = 'DescriptionList.Element';

export { DescriptionList, getDescriptionDirectionDefault, getDescriptionListIsVerticalOnMobileDefault, getDescriptionListSizeDefault, getDescriptionListVariantDefault, getDescriptionWeightDefault, getTermWeightDefault };
